<template>
  <div class="mb-3 mr-3" :style="{ marginLeft: depth * 30 + 'px' }">
    <b-list-group :class="{ 'mb-3': has_children }">
      <b-list-group-item
        button
        v-b-toggle="'collapse-' + category.id"
        class="rounded p-2 font-weight-bold border-0"
        style="background-color: #ffc600"
        :style="{ marginLeft: depth + 10 + 'px' }"
      >
        <div class="d-flex justify-content-between align-items-center">
          <h3 class="pt-2 ml-3 text-left" style="color: black">
            {{ language == "English" ? category.eng_title : category.title }}
          </h3>
          <h3
            v-if="!is_child && has_children"
            class="pt-2 mr-3 text-right"
            style="color: black"
          >
            {{ language == "English" ? "Click for more" : "點擊查看更多" }}
          </h3>
        </div>
      </b-list-group-item>
    </b-list-group>

    <b-collapse
      :id="'collapse-' + category.id"
      :visible="is_visiable || !has_children"
      class="ml-3 mb-3"
    >
      <div
        v-for="(form, index) in category.fbo_forms"
        :key="index"
        class="source_link mt-3 ml-3 mb-3"
      >
        <a
          :href="api_url + form.file"
          target="_blank"
          rel="noopener noreferrer"
        >
          <b-icon icon="download"></b-icon>

          {{ language == "English" ? form.eng_title : form.title }}
        </a>
      </div>
      <div v-if="has_children">
        <source_tree
          v-for="(child, index) in category.children"
          :key="index"
          :category="child"
          :is_visiable="true"
          :is_child="true"
        />
      </div>
    </b-collapse>
  </div>
</template>

<script setup>
import { defineProps, computed } from "vue";

const api_url = process.env.VUE_APP_API_URL;

const { category, depth, is_visiable, is_child } = defineProps({
  category: {
    type: Object,
    required: true,
  },
  depth: {
    type: Number,
    default: 0,
  },
  is_visiable: {
    type: Boolean,
    default: false,
  },
  is_child: {
    type: Boolean,
    default: false,
  },
  language: {
    type: String,
    default: "中文",
  },
});

const has_children = computed(() => {
  return category.children.length > 0;
});
</script>

<style scoped>
.source_link *,
.source_link *:hover {
  color: black !important;
  text-decoration: none !important;
}
</style>
